import { Collapse } from '@sgme/ui';
import { PayoffGraph, PayoffGraphProps } from 'components/shared/Charts/PayoffGraph';

type PayoffGraphCollapseCardProps = {
  value: Nullable<PayoffGraphProps>;
  label: string;
  isCollapsed: boolean;
  onToggle: VoidFunction;
};

export function PayoffGraphCollapseCard({ value, label, isCollapsed, onToggle }: PayoffGraphCollapseCardProps) {
  return (
    <Collapse
      icon="end"
      size="md"
      fill="fill"
      className="w-100 bg-lvl1 pe-2"
      alwaysOpen
      activeKey={!isCollapsed ? 'payoff-graph' : ''}
      onSelect={onToggle}
    >
      <Collapse.Item itemKey="payoff-graph">
        <Collapse.Header>
          <span className="px-2 text-secondary">{label}</span>
        </Collapse.Header>
        <Collapse.Body>
          <PayoffGraph axisNames={value?.axisNames} points={value?.points ?? []} />
        </Collapse.Body>
      </Collapse.Item>
    </Collapse>
  );
}
